/* Éditions Rémanence — lettrines et traduction du bouton liste d'envies (2026-10-06) */
(function () {
  var isFrench = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var LETTER = /[A-Za-zÀ-ÖØ-öø-ÿ]/;

  var MIN_DROP_CAP_LENGTH = 150; // une lettrine sur un paragraphe trop court déborde sur le suivant

  function firstLongParagraph(container) {
    var paragraphs = container.querySelectorAll('p');
    for (var i = 0; i < paragraphs.length; i++) {
      if (paragraphs[i].textContent.trim().length >= MIN_DROP_CAP_LENGTH) return paragraphs[i];
    }
    return null;
  }

  function addDropCap(container, longOnly) {
    if (!container || container.querySelector('.rm-lettrine')) return;
    var first = longOnly ? firstLongParagraph(container) : (container.querySelector('p') || container);
    if (!first) return;
    var walker = document.createTreeWalker(first, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var i = node.textContent.search(/\S/);
      if (i === -1) continue;
      if (!LETTER.test(node.textContent[i])) return; // pas de lettrine si le texte commence par « ou un chiffre
      var rest = node.splitText(i);
      var span = document.createElement('span');
      span.className = 'rm-lettrine';
      span.textContent = rest.textContent[0];
      rest.textContent = rest.textContent.slice(1);
      rest.parentNode.insertBefore(span, rest);
      return;
    }
  }

  var WISHLIST_FR = {
    'add to wishlist': 'Ajouter à mes envies',
    'added to wishlist': 'Dans mes envies',
    'remove from wishlist': 'Retirer de mes envies',
    'view wishlist': 'Voir mes envies',
    'go to wishlist': 'Voir mes envies'
  };

  function translateWishlist() {
    if (!isFrench) return;
    document.querySelectorAll('[class*="wishlisthero"] button, button[aria-label*="ishlist"]').forEach(function (btn) {
      var label = (btn.getAttribute('aria-label') || '').trim().toLowerCase();
      if (WISHLIST_FR[label]) btn.setAttribute('aria-label', WISHLIST_FR[label]);
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var key = node.textContent.replace(/ /g, ' ').trim().toLowerCase();
        if (WISHLIST_FR[key]) node.textContent = node.textContent.replace(/\S(.*\S)?/, WISHLIST_FR[key]);
      }
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; translateWishlist(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    addDropCap(document.querySelector('.product__description'));
    addDropCap(document.querySelector('.auteur-page .auteur-bio'));
    addDropCap(document.querySelector('.article-template__content'), true);
    addDropCap(document.querySelector('.main-page-title ~ .rte'), true);
    translateWishlist();
    if (isFrench) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  });
})();
